import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M296 64c-13.2 0-24 10.75-24 24v136H48V88c0-13.25-10.75-24-24-24S0 74.75 0 88v336c0 13.3 10.75 24 24 24s24-10.75 24-24V272h224v152c0 13.3 10.8 24 24 24s24-10.7 24-24V88c0-13.25-10.7-24-24-24m238.6 159.4h-34.13l115.5-118.9c6.719-6.906 8.641-17.19 4.891-26.06-3.766-8.875-12.47-14.66-22.11-14.66L400 63.94c-13.25 0-24 10.59-24 23.84s10.75 24 24 24h141.1l-115.5 118.9c-6.719 6.906-8.641 17.19-4.891 26.06 3.766 8.875 12.47 14.66 22.11 14.66h90.91c31.66 0 57.41 28.78 57.41 64.19s-25.75 64.19-57.41 64.19h-77.11c-15.52 0-29.41-11.22-34.55-27.94-3.906-12.66-17.23-19.81-30-15.88-12.67 3.906-19.78 17.31-15.88 30 11.38 36.97 43.69 61.81 80.42 61.81h77.11C592.7 447.8 640 397.5 640 335.6s-47.3-112.2-105.4-112.2",
      style: {"fill":"var(--fa-primary-color, currentColor)","opacity":"var(--fa-primary-opacity, 1)"}
    }, null, -1)
  ])))
}
export default { render: render }